module.exports = __webpack_public_path__ + "img/downtown.0f564082.jpg";